module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_seminar_attendee-00c062b085a3b0b063d9ecc316af4b75.svg";